import React from 'react';
import QRCodePrompt from "./QRCodePrompt";
import DesktopPrompt from "./DesktopPrompt";
import MobilePrompt from "./MobilePrompt";
import RedirectPrompt from "./RedirectPrompt";
import ArActivation from "./ArActivation";
import { useStore } from '../../zustand';

export default function ModalUI() {
    const modalView = useStore(state => state.modalView);
    
    switch(modalView.display) {
        case "QRCodePrompt":
            return <QRCodePrompt />
        case "DesktopPrompt":
            return <DesktopPrompt />
        case "MobilePrompt":
            return <MobilePrompt />
        case "RedirectPrompt":
            return <RedirectPrompt />
        case "ArActivation":
            return <ArActivation />            
        default:
            return null
    }
};
